import { render, staticRenderFns } from "./DonutConsultationsISTByCSP.vue?vue&type=template&id=978f9616&"
import script from "./DonutConsultationsISTByCSP.vue?vue&type=script&lang=ts&"
export * from "./DonutConsultationsISTByCSP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports